module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page8.8418973e.png";